import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { path: '/services#web', label: '.NET Web Applications' },
      { path: '/services#microservices', label: 'Microservices & APIs' },
      { path: '/services#php', label: 'PHP & Laravel' },
      { path: '/services#mobile', label: 'iOS & Android Apps' },
      { path: '/services#digital', label: 'Digital Marketing' },
    ],
    company: [
      { path: '/about', label: 'About Us' },
      { path: '/mission', label: 'Our Mission' },
      { path: '/services', label: 'Our Services' },
      { path: '/contact', label: 'Contact' },
    ],
    industries: [
      { path: '/services', label: 'Retail & eCommerce' },
      { path: '/services', label: 'Healthcare' },
      { path: '/services', label: 'Education' },
      { path: '/services', label: 'Logistics' },
      { path: '/services', label: 'Finance' },
    ],
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Logo variant="light" />
            </div>
            <p className="footer-description">
              Softnova Solutions designs and delivers .NET and PHP web platforms,
              microservices, native mobile apps, and digital growth programs for
              organizations that need a reliable product partner.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              {footerLinks.services.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Industries</h3>
            <ul className="footer-links">
              {footerLinks.industries.map((link) => (
                <li key={link.label}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-contact">
              <li>Email: info@softnovasolutions.com</li>
              <li>
                طريق الملك عبدالله, King Faisal Dt., Riyadh 14232
              </li>
              <li>
                <a href="https://softnovasolutions.com">softnovasolutions.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Softnova Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
